import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-arduino-vm';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import analytics from '../lib/analytics';
import { setDeviceData } from '../reducers/device-data';

// import { makeDeviceLibrary } from '../lib/libraries/devices/index.jsx';

import LibraryComponent from '../components/library/library.jsx';
import deviceIcon from '../components/action-menu/icon--sprite.svg';

const messages = defineMessages({
    deviceTitle: {
        defaultMessage: 'Choose an Device',
        description: 'Heading for the device library',
        id: 'gui.deviceLibrary.chooseADevice'
    },
    deviceUrl: {
        defaultMessage: 'Enter the URL of the device',
        description: 'Prompt for unoffical device url',
        id: 'gui.deviceLibrary.deviceUrl'
    },
    arduinoTag: {
        defaultMessage: 'Arduino',
        description: 'Arduino tag to filter all arduino devices.',
        id: 'gui.deviceLibrary.arduinoTag'
    },
    kitTag: {
        defaultMessage: 'Kit',
        description: 'Kit tag to filter all kit devices.',
        id: 'gui.deviceLibrary.kitTag'
    },
    robotTag: {
        defaultMessage: 'Robot',
        description: 'Robot tag to filter all robot devices.',
        id: 'gui.deviceLibrary.robotTag'
    },
    espTag: {
        defaultMessage: 'ESP',
        description: 'ESP tag to filter all ESP32, ESP8266 devices.',
        id: 'gui.deviceLibrary.espTag'
    },
});

const ARDUINO_TAG = { tag: 'Arduino', intlLabel: messages.arduinoTag };
const KIT_TAG = { tag: 'Kit', intlLabel: messages.kitTag };
const ROBOT_TAG = { tag: 'Robot', intlLabel: messages.robotTag };
const ESP_TAG = { tag: 'ESP', intlLabel: messages.espTag };
const tagListPrefix = [ARDUINO_TAG, KIT_TAG, ROBOT_TAG, ESP_TAG];

class DeviceLibrary extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }
    // Disable get device list from local host link
    // componentDidMount () {
    //     this.props.vm.extensionManager.getDeviceList().then(data => {
    //         if (data) {
    //             this.props.onSetDeviceData(makeDeviceLibrary(data));
    //         }
    //     });
    // }

    handleItemSelect(item) {
        const id = item.deviceId;
        const deviceType = item.type;
        const pnpidList = item.pnpidList;
        const deviceExtensions = item.deviceExtensions;

        if (id && !item.disabled) {
            if (this.props.vm.extensionManager.isDeviceLoaded(id)) {
                this.props.onDeviceSelected(id);
            } else {
                this.props.onDeviceChanged();
                this.props.vm.extensionManager.loadDeviceURL(id, deviceType, pnpidList).then(() => {
                    // this.props.vm.extensionManager.getDeviceExtensionsList().then(() => {
                    //     // TODO: Add a event for install device extension
                    //     // the large extensions will take many times to load
                    //     // A loading interface should be launched.
                    //     this.props.vm.installDeviceExtensions(deviceExtensions);
                    // });
                    this.props.onDeviceSelected(id);
                    analytics.event({
                        category: 'devices',
                        action: 'select device',
                        label: id
                    });
                });
            }
        }
    }

    render() {
        const deviceLibraryThumbnailData = this.props.deviceData.map(device => ({
            rawURL: device.iconURL || deviceIcon,
            ...device
        }));

        return (
            <LibraryComponent
                data={deviceLibraryThumbnailData}
                filterable
                tags={tagListPrefix}
                id="deviceLibrary"
                title={this.props.intl.formatMessage(messages.deviceTitle)}
                visible={this.props.visible}
                onItemSelected={this.handleItemSelect}
                onRequestClose={this.props.onRequestClose}
            />
        );
    }
}

DeviceLibrary.propTypes = {
    deviceData: PropTypes.instanceOf(Array).isRequired,
    intl: intlShape.isRequired,
    onDeviceChanged: PropTypes.func,
    onDeviceSelected: PropTypes.func,
    onRequestClose: PropTypes.func,
    onSetDeviceData: PropTypes.func.isRequired,
    visible: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired // eslint-disable-line react/no-unused-prop-types
};

const mapStateToProps = state => ({
    deviceData: state.scratchGui.deviceData.deviceData
});

const mapDispatchToProps = dispatch => ({
    onSetDeviceData: data => dispatch(setDeviceData(data))
});

export default compose(
    injectIntl,
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(DeviceLibrary);
